<template> 
  <div class="portada-xv" ref="rootRef" aria-label="Portada de XV">

    <!-- 🌿 DECORACIONES EN LAS ESQUINAS -->
    <img src="@/assets/decor.png" class="decoracion-esquina esquina-top-left" alt="Decoración" />
    <img src="@/assets/decor.png" class="decoracion-esquina esquina-bottom-right" alt="Decoración" />

    <!-- IMAGEN PRINCIPAL EN MARCO DE ARCO -->
    <div class="imagen-xv-wrapper" ref="fotoRef">
      <img src="@/assets/Gemini_Generated_Image_atz0lyatz0lyatz0 (1).jpeg" class="imagen-xv" alt="Foto protagonista" />
    </div>

    <!-- SECCIÓN DE TEXTO UBICADA DEBAJO DE LA IMAGEN -->
    <section class="texto-xv" ref="textoRef">

      <p class="frase-bendicion" ref="bendicionRef">
        Con la bendición de Dios <br />
        y de mis padres
      </p>

      <h1 class="nombre-protagonista" ref="nombre1Ref">
        Cleotilde <br> Sánchez Barragán
      </h1>

      <!-- 💎 AMPERSAND PADRES -->
      <img
        src="@/assets/ampersand.png"
        class="ampersand"
        alt="&"
        ref="ampRef"
      />

      <div class="nombre-con-cruz" ref="nombre2Ref">
        <h1 class="nombre-protagonista">
          Efrén <br> Ruiz Reséndiz
        </h1>
        <i class="fas fa-cross icono-cruz-cafe"></i>
      </div>

      <p class="parrafo-presentacion" ref="parrafoRef">
        Un día soñé con este momento y hoy, con el corazón lleno de gratitud y alegría, doy la bienvenida a mis quince años. Es un honor para mí que formes parte de este día que llevaré por siempre.
      </p>

      <p class="salmo-ref" ref="salmoRef">
        Mis 15 años
      </p>

      <br />

      <!-- 🕊️ SECCIÓN PADRINOS DEBAJO DE MIS 15 AÑOS -->
      <div class="seccion-padrinos">
        <div class="separador-padrinos" ref="separadorPadrinosRef"></div>

        <p class="frase-bendicion subtitulo-padrinos" ref="padrinosLabelRef">
          Mis padrinos
        </p>

        <h2 class="nombre-protagonista nombre-padrino" ref="padrino1Ref">
          Prisca <br />Sánchez Rocha
        </h2>

        <img
          src="@/assets/ampersand.png"
          class="ampersand ampersand-padrino"
          alt="&"
          ref="ampPadrinosRef"
        />

        <h2 class="nombre-protagonista nombre-padrino" ref="padrino2Ref">
          Miguel Ángel <br />Rodríguez Gonzalez
        </h2>
      </div>

    </section>
  </div>
</template>

<script>
import { onMounted, ref, nextTick } from 'vue'
import gsap from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'

gsap.registerPlugin(ScrollTrigger)

export default {
  name: 'PortadaArley',

  setup() {
    const rootRef = ref(null)

    const fotoRef = ref(null)
    const bendicionRef = ref(null)
    const nombre1Ref = ref(null)
    const nombre2Ref = ref(null)
    const ampRef = ref(null)
    const parrafoRef = ref(null)
    const salmoRef = ref(null)

    // Refs para padrinos
    const separadorPadrinosRef = ref(null)
    const padrinosLabelRef = ref(null)
    const padrino1Ref = ref(null)
    const ampPadrinosRef = ref(null)
    const padrino2Ref = ref(null)

    onMounted(async () => {
      await nextTick()

      // TIMELINE CONSECUTIVA GSAP
      const tl = gsap.timeline({
        scrollTrigger: {
          trigger: rootRef.value,
          start: 'top 80%',
          once: true
        }
      })

      /* 1. APARICIÓN DE LA FOTO */
      tl.fromTo(
        fotoRef.value,
        { opacity: 0, scale: 0.9, y: 50, filter: 'blur(8px)' },
        { opacity: 1, scale: 1, y: 0, filter: 'blur(0px)', duration: 1.2, ease: 'power3.out' }
      )

      /* 2. FRASE BENDICIÓN */
      .fromTo(
        bendicionRef.value,
        { opacity: 0, y: 25 },
        { opacity: 1, y: 0, duration: 0.8, ease: 'power2.out' },
        '-=0.4'
      )

      /* 3. PRIMER NOMBRE PADRE */
      .fromTo(
        nombre1Ref.value,
        { opacity: 0, y: 30 },
        { opacity: 1, y: 0, duration: 1, ease: 'power3.out' },
        '-=0.3'
      )

      /* 4. AMPERSAND DECORATIVO PADRES */
      .fromTo(
        ampRef.value,
        { opacity: 0, scale: 0.2, rotate: -20 },
        { opacity: 1, scale: 1, rotate: 0, duration: 0.6, ease: 'back.out(2)' },
        '-=0.4'
      )

      /* 5. SEGUNDO NOMBRE PADRE CON CRUZ */
      .fromTo(
        nombre2Ref.value,
        { opacity: 0, y: 30 },
        { opacity: 1, y: 0, duration: 1, ease: 'power3.out' },
        '-=0.3'
      )

      /* 6. PÁRRAFO EMOCIONAL */
      .fromTo(
        parrafoRef.value,
        { opacity: 0, y: 25 },
        { opacity: 1, y: 0, duration: 0.9, ease: 'power2.out' },
        '-=0.3'
      )

      /* 7. PIE MIS 15 AÑOS */
      .fromTo(
        salmoRef.value,
        { opacity: 0, scale: 0.8, y: 20 },
        { opacity: 1, scale: 1, y: 0, duration: 0.9, ease: 'back.out(1.7)' },
        '-=0.3'
      )

      /* 8. SEPARADOR DE PADRINOS */
      .fromTo(
        separadorPadrinosRef.value,
        { width: '0%', opacity: 0 },
        { width: '120px', opacity: 1, duration: 0.8, ease: 'power2.out' },
        '-=0.2'
      )

      /* 9. LABEL MIS PADRINOS */
      .fromTo(
        padrinosLabelRef.value,
        { opacity: 0, y: 20 },
        { opacity: 1, y: 0, duration: 0.8, ease: 'power2.out' },
        '-=0.3'
      )

      /* 10. PRIMER PADRINO */
      .fromTo(
        padrino1Ref.value,
        { opacity: 0, y: 25 },
        { opacity: 1, y: 0, duration: 0.9, ease: 'power3.out' },
        '-=0.3'
      )

      /* 11. AMPERSAND PADRINOS */
      .fromTo(
        ampPadrinosRef.value,
        { opacity: 0, scale: 0.2, rotate: -20 },
        { opacity: 1, scale: 1, rotate: 0, duration: 0.6, ease: 'back.out(2)' },
        '-=0.4'
      )

      /* 12. SEGUNDO PADRINO */
      .fromTo(
        padrino2Ref.value,
        { opacity: 0, y: 25 },
        { opacity: 1, y: 0, duration: 0.9, ease: 'power3.out' },
        '-=0.3'
      )
    })

    return {
      rootRef,
      fotoRef,
      bendicionRef,
      nombre1Ref,
      nombre2Ref,
      ampRef,
      parrafoRef,
      salmoRef,
      separadorPadrinosRef,
      padrinosLabelRef,
      padrino1Ref,
      ampPadrinosRef,
      padrino2Ref
    }
  }
}
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Cinzel:wght@600;700&family=Great+Vibes&family=Playfair+Display:ital,wght@0,400;0,500;0,600;1,400;1,500&family=Poppins:wght@400;500;600&display=swap');

/* =========================
   CONTENEDOR PRINCIPAL
========================= */
.portada-xv {
  position: relative;
  width: 100%;
  min-height: 100vh;
  overflow: hidden;

  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 40px 20px 60px;
  box-sizing: border-box;

  background-color: #f5f0e6;

  z-index: 1;
  isolation: isolate;
}

/* =========================
   DECORACIÓN EN ESQUINAS
========================= */
.decoracion-esquina {
  position: absolute;
  width: min(42vw, 200px);
  height: auto;
  pointer-events: none;
  z-index: 2;
  opacity: 0.9;
}

.esquina-top-left {
  top: 0;
  left: 0;
}

.esquina-bottom-right {
  bottom: 0;
  right: 0;
  transform: rotate(180deg);
}

/* =========================
   IMAGEN PRINCIPAL EN MARCO DE ARCO
========================= */
.imagen-xv-wrapper {
  position: relative;
  z-index: 5;
  width: min(88vw, 320px);
  height: calc(min(88vw, 320px) * 1.4);
  margin-top: 20px;

  border-radius: 160px 160px 16px 16px;
  overflow: hidden;
  background: #ffffff;
  border: 1.5px solid #cba56b;

  box-shadow:
    0 12px 35px rgba(73, 121, 160, 0.12),
    0 4px 12px rgba(0, 0, 0, 0.06);
}

.imagen-xv {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}

/* =========================
   SECCIÓN DE TEXTO (UBICADA DEBAJO DE LA FOTO)
========================= */
.texto-xv {
  position: relative;
  z-index: 6;
  width: 100%;
  max-width: 580px;
  text-align: center;
  margin-top: 35px;
  padding: 0 10px;
  box-sizing: border-box;
}

/* FRASE SUPERIOR */
.frase-bendicion {
  font-family: 'Playfair Display', serif;
  font-size: clamp(16px, 2.4vw, 20px);
  color: #383838;
  font-weight: 400;
  line-height: 1.5;
  margin: 0 0 18px;
  text-transform: none;
}

/* NOMBRES DESTACADOS EN AZUL CELESTE */
.nombre-protagonista {
  font-family: 'Playfair Display', serif;
  font-size: clamp(26px, 4.2vw, 36px);
  font-weight: 600;
  color: #5c8ba6;
  text-transform: none;
  line-height: 1.25;
  margin: 10px 0;
  filter: drop-shadow(0 1px 2px rgba(0, 0, 0, 0.04));
}

/* CONTENEDOR FLEX PARA CRUZ AL LADO DEL NOMBRE COMPLETO */
.nombre-con-cruz {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  margin: 10px auto;
}

.nombre-con-cruz .nombre-protagonista {
  margin: 0;
}

/* ÍCONO DE CRUZ FINADO EN TONO CAFÉ ELEGANTE */
.icono-cruz-cafe {
  font-size: 1.2rem;
  color: #8c6d46;
  margin-left: 2px;
}

/* AMPERSAND DORADO EN CURSIVA */
.ampersand {
  display: block;
  margin: 12px auto;
  width: 58px;
  height: auto;
  z-index: 7;
  position: relative;
  filter: brightness(0) saturate(100%) invert(69%) sepia(26%) saturate(693%) hue-rotate(1deg) brightness(93%) contrast(88%);
}

/* PÁRRAFO PRINCIPAL EN CURSIVA ELEGANTE Y MATE */
.parrafo-presentacion {
  font-family: 'Playfair Display', serif;
  font-size: clamp(16px, 2.3vw, 20px);
  font-style: italic;
  color: #2b2b2b;
  line-height: 1.7;
  margin: 28px auto 22px;
  max-width: 500px;
  text-transform: none;
}

/* PIE MIS 15 AÑOS EN AZUL CELESTE */
.salmo-ref {
  text-align: center;
  font-family: 'Playfair Display', serif;
  font-size: clamp(28px, 4.5vw, 38px);
  font-weight: 600;
  color: #5c8ba6;
  margin: 15px 0 0;
  text-transform: none;
}

/* ESTILOS ESPECÍFICOS DE PADRINOS */
.seccion-padrinos {
  margin-top: 25px;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.separador-padrinos {
  width: 120px;
  height: 1.5px;
  background: linear-gradient(90deg, transparent, #cba56b, transparent);
  margin: 0 auto 20px;
}

.subtitulo-padrinos {
  margin-bottom: 12px;
  font-style: italic;
}

.nombre-padrino {
  font-size: clamp(18px, 3.5vw, 18px);
  margin: 6px 0;
}

.ampersand-padrino {
  width: 46px;
  margin: 8px auto;
}

@media (max-width: 480px) {
  .portada-xv {
    padding: 30px 15px 45px;
  }
  
  .texto-xv {
    margin-top: 25px;
  }

  .icono-cruz-cafe {
    font-size: 1rem;
  }
}
</style>